module.exports = __webpack_public_path__ + "img/1525654584.d3a5cd66.jpg";